<div *ngIf="offline" style="display: flex; flex-direction: column; height: 100%;">
  <div class="row justify-content-center">
    <h1 class="display-1" style="color: #ff6f61;" align="center">Submission not allowed while offline</h1>
  </div>
</div>


<div *ngIf="!offline && !finalSubmit && canSubmit" style="display: flex; flex-direction: column; height: 100%;">

  <!-- Submit delivery: step 1 -->
  <div class="row justify-content-center">

    <button mat-icon-button
            class="color-button-orange"
            type="button"
            (click)="finalSubmit = true">
      <mat-icon>
        cloud_upload
      </mat-icon>
    </button>

    <h1 class="display-1" style="color: #ff6f61;" align="center">Submit Logbook</h1>

  </div>

  <br>
  <br>
  <br>
  <br>
  <br>

  <!-- Back to delivery details -->
  <div class="row justify-content-start" style="margin-top: auto;">
    <button mat-fab
            class="color-button-orange"
            type="button"
            matTooltip="Back to Delivery"
            matTooltipPosition="above"
            (click)="dialogRef.close()">
      <mat-icon>
        arrow_back
      </mat-icon>
    </button>
  </div>
</div>


<div *ngIf="!offline && finalSubmit" style="display: flex; flex-direction: column; height: 100%;">
  <div class="row justify-content-center">

    <h1 class="display-1" style="color: #ff6f61;" align="center">I certify under penalty of perjury that I have reviewed all the information in this form and that it is true and complete to the best of my knowledge.</h1>

    <!-- Submit delivery: step 2 -->
    <button mat-icon-button
            class="color-button-orange"
            type="submit"
            (click)="dialogRef.close({submit: true})">
      <mat-icon>
        cloud_upload
      </mat-icon>
    </button>

    <h1 class="display-1" style="color: #ff6f61;" align="center">Confirm and Submit</h1>


  </div>

  <!-- Go back to delivery details -->
  <div class="row justify-content-start" style="margin-top: auto;">
    <button mat-fab
            class="color-button-orange"
            type="button"
            matTooltip="Back to Submit"
            matTooltipPosition="above"
            (click)="finalSubmit = false">
      <mat-icon>
        arrow_back
      </mat-icon>
    </button>
  </div>
</div>

<!-- Errors present upon trying to submit delivery -->
<div *ngIf="!offline && !canSubmit" style="display: flex; flex-direction: column; height: 100%;">
  <div class="row justify-content-center">

    <h1 class="display-1" style="color: #ff6f61;" align="center">Cannot Submit until errors resolved!</h1>
    <button mat-icon-button
            class="color-button-orange"
            type="button"
            (click)="dialogRef.close({errors: true})">
      <mat-icon>
        error
      </mat-icon>
    </button>
    <h1 class="display-1" style="color: #ff6f61;" align="center">Go to errors/warnings</h1>

  </div>
</div>
